import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(1),
  },
  subtitle: {
    marginTop: theme.spacing(0.5),
    fontSize: "12px",
    fontWeight: 400,
  },
  helpLink: {
    color: theme.palette.blue.main,
  },
  content: {
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(1.25),
    display: "flex",
    alignItems: "center",
  },
  requestButton: {
    color: theme.palette.blue.main,
  },
  customDomainInput: {
    width: "300px",
  },
  checkButton: {
    textDecoration: "none",
  },
  editButton: {
    lineHeight: "normal",
    color: theme.palette.text.primary,
  },
  editButtonContent: {
    height: "17px",
  },
}));
